import api from './api';
import { API_ROUTES } from '../config/apiRoutes';
import config from '../config/config';

export const userService = {

  googleLoginRoute: config.api.baseUrl + '/oauth2/authorization/google',

  logout: async () => {
    return api.post(API_ROUTES.users.logout);
  },
  
  upsert: async () => {
    return api.post(API_ROUTES.users.upsert);
  },
  
  getProfile: async () => {
    try {
      const response = await api.get(API_ROUTES.users.profile.get); // Using the profile GET endpoint
      if (response === null) {
        return null;
      }
      return response;
    } catch (error) {
      console.error('Error in getProfile:', error);
      return null;
    }
  },

  
  updateProfile: async (profileData) => {
    try {
      return await api.put(API_ROUTES.users.profile.update, profileData);
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  },

};
